import React, { Component } from 'react';
import { connectStateResults } from 'react-instantsearch-dom';
import EventCalendarListing from '../components/EventCalendarListing';
import moment from '../utils/momentTimeZone'
import LoadMoreNextWeek from './LoadMoreNextWeek';


class ByDayHits extends Component {
    render() {
        const {hits, dateRange} = this.props
        const hitsByDay = groupHitsByDay(hits)


        return (
            <div>
                {hits.length === 0 && dateRange && dateRange.range && dateRange.range.unixDay &&
                <div className="o-layout o-layout--center">
                    <div className="o-layout__item u-1/1@desktop">
                        <div className="fadeIn c-no-events-label">
                            <p>
                                <strong>
                                    There are no events currently scheduled<br/>
                                    between {moment.unix(dateRange.range.unixDay.min).format('D MMMM')} and {moment.unix(dateRange.range.unixDay.max).format('D MMMM')}
                                </strong>
                            </p>
                            <button type="button" className="c-btn c-btn--red" onClick={this.onViewTodayClick}>View today's events</button>
                        </div>
                    </div>
                </div>
                }
                
                {hits.length > 0 &&

                

                <div>                                                
                    {Object.entries(hitsByDay).map(([unixDay, dayHits]) => (
                        <div className="c-day-block fadeIn" key={unixDay}>
                            <div className="fadeIn c-booking-fee-info u-rich-white-bg">
                                <div className="c-col-text-area">
                                    <p>
                                        *Includes a £3 transaction fee per order, and a £1 restoration levy per ticket. Become a{" "}
                                        <a href="/join-and-support/best-friends/">Best Friend</a> or{" "}
                                        <a href="/join-and-support/membership/patron-membership/">Patron</a>{" "}
                                        to book without transaction fee. Free events and £5 or £10 standing tickets for performances are exempt.
                                    </p>
                                </div>
                            </div>
                            <div className="c-day-block__inner o-max o-max--1200">
                                <div className="c-day-events">

                                    <div className="c-day-block__date-holder">
                                        <h4 className="c-day-block__date">
                                            {moment.unix(unixDay).format('dddd D')}
                                            <span className="c-day-block__date--month">{moment.unix(unixDay).format('MMMM')}</span>
                                        </h4>
                                    </div>
                                    <div key={unixDay}>
                                        {dayHits.map((hit) => (
                                            <EventCalendarListing
                                                key={hit.objectID}
                                                hit={hit}
                                            />
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                                
                            
                    <div className="c-whats-on-LoadMore">
                        <LoadMoreNextWeek attribute="unixDay" />
                    </div>
                </div>}
            </div>
        )
    }

    onViewTodayClick() {
        window.dispatchEvent(new CustomEvent("whatson:view-today"));
    }
}

export default connectStateResults(({dateRange, searchResults }) => {
    return (searchResults && <ByDayHits hits={searchResults.hits} dateRange={dateRange} />)
})


function groupHitsByDay(hits) {
    return hits.reduce((acc, hit) => {
        const day = hit.unixDay
        if (!acc[day]) {
            acc[day] = []
        }
        acc[day].push(hit)
        return acc
    }, {})
}


// WEBPACK FOOTER //
// ./src/whatson/components/ByDayHits.js